import Axios from '@/components/api/axios.js'
/**********************************************************************************
 * 实时数据
 **********************************************************************************/
export default {
	/**
	 * 对指定的用户推送消息
	 */
	pushMsgByUserId: (userId, func, cmd, state, data, tag, success, failure) => {
		Axios.post('/debug/pushMsgByUserId.do', {
			userId,
			func,
			cmd,
			state,
			data,
			tag
		}, success, failure)
	},
	/**
	 * 对指定的用户账户推送消息
	 */
	pushMsgByUserCode: (userCode, func, cmd, state, data, tag, success, failure) => {
		Axios.post('/debug/pushMsgByUserCode.do', {
			userCode,
			func,
			cmd,
			state,
			data,
			tag
		}, success, failure)
	},
	/**
	 * 模拟上位机发送消息
	 */
	testCSMsg: (msg, success, failure) => {
		Axios.post('/debug/testCSMsg.do', {
			msg
		}, success, failure)
	},

}
